module.exports = __webpack_public_path__ + "static/media/bg-player.ebffbc25.jpg";